// extracted by mini-css-extract-plugin
export var container = "_dc-0";
export var infoIcon = "_dc-2";
export var titleRowCol = "_dc-1";